import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
	languagesLevel1: Yup.array(),
	languagesLevel2: Yup.array(),
	languagesLevel3: Yup.array(),
});

const programmingLanguages = ["javascript", "java", "cpp", "python", "other"];
const mapLanguages = {
	javascript: "JavaScript",
	java: "Java",
	cpp: "C++",
	python: "Python",
	other: "Other",
};

const UserFormPage = () => {
    const navigate = useNavigate();

	const onSubmit = (values) => {
		if (
			!values.languagesLevel1.length &&
			!values.languagesLevel2.length &&
			!values.languagesLevel3.length
		) {
			alert("Please select at least one language at any level.");
			return;
		}

		if (
			(values.languagesLevel1.length === 0 || (values.languagesLevel1.length === 1 && values.languagesLevel1[0] === "other"))
			&& (values.languagesLevel2.length === 0 || (values.languagesLevel2.length === 1 && values.languagesLevel2[0] === "other"))
			&& (values.languagesLevel3.length === 0 || (values.languagesLevel3.length === 1 && values.languagesLevel3[0] === "other"))
		) {
			alert("Unfortunately, we currently suppport only JavaScript, Java, C++ and Python. Please select at least one of these languages if you wish to continue.");
			return;
		}
		
		localStorage.setItem("user", JSON.stringify(values));

		navigate("/score");
	};

	return (
		<div className="App">
			<div className="App-header">
				Functional Similarity Evaluation
			</div>
			<div>
				<div className="description">
					<b style={{ color: "#00CBC4", fontSize: "1.3rem" }}>
						User Details
					</b>
				</div>
				<Formik
					initialValues={{
						email: "",
						languagesLevel1: [],
						languagesLevel2: [],
						languagesLevel3: [],
					}}
					validateOnBlur={false}
					validateOnChange={false}
					validationSchema={validationSchema}
					onSubmit={onSubmit}
				>
					{({ errors, touched }) => (
						<Form style={{ maxWidth: "600px", marginLeft: "auto", marginRight: "auto" }}>
							<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
								<div style={{ color: "white", fontSize: "1.2rem" }}>Email (optional):</div>
								<Field type="text" id="email" name="email" />
							</div>
							{errors.email && touched.email ? (
								<div className="form-errors">{errors.email}</div>
							) : null}
							<div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", marginTop: "20px" }}>
								<div style={{ color: "white", fontSize: "1.2rem" }}>Programming Languages Level 1 (Taught at university/course):</div>
							</div>
							<div role="group" aria-labelledby="checkbox-group" style={{ marginTop: "10px", display: "flex", justifyContent: "space-evenly" }}>
								{programmingLanguages.map((language) => (
									<div key={language} style={{ display: "flex", alignItems: "center" }}>
										<Field type="checkbox" name="languagesLevel1" value={language} />
										<div style={{ color: "white", fontSize: "1rem", marginLeft: "5px" }}>
											{mapLanguages[language]}
										</div>
									</div>
								))}
							</div>
							{errors.languagesLevel1 && touched.languagesLevel1 ? (
								<div className="form-errors">{errors.languagesLevel1}</div>
							) : null}
							<div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", marginTop: "20px" }}>
								<div style={{ color: "white", fontSize: "1.2rem" }}>Programming Languages Level 2 (Used in personal projects):</div>
							</div>
							<div role="group" aria-labelledby="checkbox-group" style={{ marginTop: "10px", display: "flex", justifyContent: "space-evenly" }}>
								{programmingLanguages.map((language) => (
									<div key={language} style={{ display: "flex", alignItems: "center" }}>
										<Field type="checkbox" name="languagesLevel2" value={language} />
										<div style={{ color: "white", fontSize: "1rem", marginLeft: "5px" }}>
											{mapLanguages[language]}
										</div>
									</div>
								))}
							</div>
							{errors.languagesLevel2 && touched.languagesLevel2 ? (
								<div className="form-errors">{errors.languagesLevel2}</div>
							) : null}
							<div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", marginTop: "20px" }}>
								<div style={{ color: "white", fontSize: "1.2rem" }}>Programming Languages Level 3 (Used in professional environment):</div>
							</div>
							<div role="group" aria-labelledby="checkbox-group" style={{ marginTop: "10px", display: "flex", justifyContent: "space-evenly" }}>
								{programmingLanguages.map((language) => (
									<div key={language} style={{ display: "flex", alignItems: "center" }}>
										<Field type="checkbox" name="languagesLevel3" value={language} />
										<div style={{ color: "white", fontSize: "1rem", marginLeft: "5px" }}>
											{mapLanguages[language]}
										</div>
									</div>
								))}
							</div>
							{errors.languagesLevel3 && touched.languagesLevel3 ? (
								<div className="form-errors">{errors.languagesLevel3}</div>
							) : null}
							<button
								className="submit-button"
								type="submit"
							>
								Submit
							</button>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
};

export default UserFormPage;
